import { getApiBaseUrl as getConfiguredApiBaseUrl, getApiKey as getConfiguredApiKey } from 'fake-db/apiConfig'
import Mock from '../mock'
import axios from 'axios.js'
const getApiBase = () => getConfiguredApiBaseUrl()
const getApiKey = () => getConfiguredApiKey()

Mock.onGet('/api/telephony/poll').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=telephony/poll/`)
        const payload = response?.data || {}
        if (payload?.data?.calls && Array.isArray(payload.data.calls)) {
            return [200, { calls: payload.data.calls }]
        }
        if (Array.isArray(payload?.calls)) {
            return [200, { calls: payload.calls }]
        }
        return [200, { calls: [] }]
    } catch (e) {
        console.error('telephony poll proxy error', e)
        return [200, { calls: [] }]
    }
})

Mock.onGet('/api/telephony/logs').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=telephony/logs/`)
        return [200, response?.data || {}]
    } catch (e) {
        console.error('telephony logs proxy error', e)
        return [500, { message: 'Ошибка получения логов телефонии' }]
    }
})

Mock.onPost('/api/telephony/fake-call').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=telephony/fake-call/`,
            data || {}
        )
        const payload = response?.data || {}
        if (payload?.data?.call) {
            return [200, { call: payload.data.call }]
        }
        return [200, payload]
    } catch (e) {
        console.error('telephony fake-call proxy error', e)
        const body = config?.data ? JSON.parse(config.data) : {}
        const call = {
            callId: `fake_${Date.now()}`,
            from: body?.from || '+79991112233',
            to: body?.to || 'operator',
            status: body?.status || 'ringing',
            klientId: body?.klientId || null,
            klientName: body?.klientName || null,
            timestamp: Date.now(),
        }
        return [200, { call }]
    }
})

Mock.onGet('/api/telephony/settings').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=telephony/settings/get/`)
        return [200, response?.data || {}]
    } catch (e) {
        console.error('telephony settings get error', e)
        return [500, { message: 'Ошибка получения настроек телефонии' }]
    }
})

Mock.onPost('/api/telephony/settings/save').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=telephony/settings/save/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('telephony settings save error', e)
        return [500, { message: 'Ошибка сохранения настроек телефонии' }]
    }
})

Mock.onPost('/api/telephony/operator/resolve-employee').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=telephony/operator/resolve-employee/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('telephony resolve employee error', e)
        return [500, { message: 'Ошибка определения employee_id через Novofon API' }]
    }
})

Mock.onPost('/api/telephony/connection/check').reply(async () => {
    try {
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=telephony/connection/check/`,
            {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('telephony connection check error', e)
        return [500, { message: 'Ошибка проверки подключения к Novofon' }]
    }
})

Mock.onPost('/api/telephony/call/callback-done').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=telephony/call/callback-done/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('telephony callback done error', e)
        return [500, { message: 'Ошибка отметки звонка как перезвоненного' }]
    }
})
